import { render } from "./MyOffCanvasMobileMenu.vue?vue&type=template&id=0b4e15b4"
import script from "./MyOffCanvasMobileMenu.vue?vue&type=script&lang=js"
export * from "./MyOffCanvasMobileMenu.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__